import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Zeta from "../images/david-holifield-4SLhp1olvFc-unsplash.jpg"

const SecondPage = () => (
  <Layout>
    <SEO title="Hybrid kukurice ZETA 325G" />
    <section className="text-gray-700 body-font overflow-hidden">
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <div className="lg:w-1/2 w-full lg:pr-10 lg:py-6 mb-6 lg:mb-0">
            <h2 className="text-sm title-font text-gray-500 tracking-widest">
              FAO 325
            </h2>
            <h1 className="text-gray-900 text-3xl title-font font-medium mb-4">
              ZETA 325G
            </h1>
            <div className="flex mb-4">
              <span className="flex-grow text-indigo-500 border-b-2 border-indigo-500 py-2 text-lg px-1">
                Odporúčania pre pestovateľov
              </span>
            </div>
            <p className="leading-relaxed text-justify mb-4">
              Hybrid kukurice ZETA 325 G je vhodný na pestovanie do teplej časti
              repárskej výrobnej oblasti pre vyššie a stabilné úrody zrna a tiež
              pre špeciálne využitie na CCM a LKS z dôvodu vyššieho podielu
              šúľkov a vyššej výťažnosti škrobu zo zrna. Veľmi významným znakom
              tohto hybridu je tiež odolnosť k poliehaniu v podmienkach silných
              vetrov a výdatných dažďov. Doporučujeme pestovanie na zrno pri 80
              000 rastlín na ha a pre špeciálne pestovanie (CCM, LKS) z dôvodu
              vyššieho obsahu škrobu pri hustote 90 000 rastlín na ha.
            </p>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ hybridu</span>
              <span className="ml-auto text-gray-900">Sc</span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Typ zrna</span>
              <span className="ml-auto text-gray-900">konský zub</span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Organizácia porastu:
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2">
              <span className="text-gray-500">Pre pestovanie na zrno</span>
              <span className="ml-auto text-gray-900">
                80 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>
            <div className="flex border-t border-gray-300 py-2 mb-6">
              <span className="text-gray-500">Pre pestovanie na CCM a LKS</span>
              <span className="ml-auto text-gray-900">
                90 000
                <br />
                <span className="text-xs">rastlín na ha</span>
              </span>
            </div>

            <div className="flex py-2">
              <span className="title-font font-medium text-2xl text-gray-900">
                Hospodárske vlastnosti:
              </span>
            </div>

            <div className="flex border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Stredne skorý hybrid kukurice na zrno do teplej časti
                    repárskej výrobnej oblasti, tiež na CCM a LKS
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vyššie a stabilné úrody zrna{" "}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vysoká odolnosť stebla k poliehaniu
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Vyšší a stabilný obsah škrobu
                  </span>
                </div>
              </div>
            </div>

            <div className="flex border-t border-gray-300">
              <div className="p-2  w-full">
                <div className="bg-gray-200 rounded flex p-4 h-full items-center">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    className="text-indigo-500 w-6 h-6 flex-shrink-0 mr-4"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                    <path d="M22 4L12 14.01l-3-3"></path>
                  </svg>
                  <span className="title-font font-medium">
                    Stabilita v rozdielnych podmienkach (kontinetálne aj
                    prímorské)
                  </span>
                </div>
              </div>
            </div>
          </div>
          <img
            alt="Hybrid kukurice ZETA 325 G"
            className="lg:w-1/2 w-full lg:h-auto h-64 object-cover object-center rounded"
            src={Zeta}
          />
        </div>
      </div>
    </section>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky v ŠOŠ SR za roky 2007 – 2008 (priemer lokalít):
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <tbody>
          <tr>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              rowspan="2"
            >
              Hybrid
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Úroda suchých šúľkov (t/ha)
            </td>
            <td
              className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2"
              colspan="3"
            >
              Sušina zrna (%)
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2007
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2008
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2007
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              2008
            </td>
            <td className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl border-2">
              Priemer
            </td>
          </tr>
          <tr>
            <td className="px-4 py-3">ZETA 325 G</td>
            <td className="bg-gray-100 px-4 py-3 ">7,76</td>
            <td className="bg-gray-100 px-4 py-3 ">6,88</td>
            <td className="bg-gray-100 px-4 py-3 ">7,32</td>
            <td className="bg-gray-100 px-4 py-3 ">49,50</td>
            <td className="bg-gray-100 px-4 py-3 ">59,60</td>
            <td className="bg-gray-100 px-4 py-3 ">54,60</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">Priemer kontrol</td>
            <td className="px-4 py-3 bg-gray-300">7,61</td>
            <td className="px-4 py-3 bg-gray-300">6,25</td>
            <td className="px-4 py-3 bg-gray-300">6,93</td>
            <td className="px-4 py-3 bg-gray-300">51,40</td>
            <td className="px-4 py-3 bg-gray-300">56,50</td>
            <td className="px-4 py-3 bg-gray-300">54,00</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="lg:w-2/3 w-full mx-auto overflow-auto py-4 mb-6">
      <h2 className="text-2xl text-gray-900 text-center font-medium leading-none py-4 mb-6 mt-2">
        Výsledky v ŠOŠ SR v roku 2007 v Haniske (suchá oblasť) :
      </h2>

      <table className="table-auto w-full text-left whitespace-no-wrap py-2">
        <thead>
          <tr>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400 rounded-tl rounded-bl">
              HYBRID
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Úroda suchých šúľkov (t/ha)
            </th>
            <th className="px-4 py-3 title-font tracking-wider font-medium text-gray-900 text-sm bg-gray-400">
              Sušina zrna (%)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="px-4 py-3 ">ZETA 325 G</td>
            <td className="bg-gray-100 px-4 py-3 ">6,94</td>
            <td className="bg-gray-100 px-4 py-3">74,10</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-300">LG 23.07</td>
            <td className="bg-gray-300 px-4 py-3 ">6,07</td>
            <td className="px-4 py-3 bg-gray-300">70,00</td>
          </tr>
          <tr>
            <td className="px-4 py-3 bg-gray-200">PR37F73</td>
            <td className="bg-gray-200 px-4 py-3 ">6,77</td>
            <td className="px-4 py-3 bg-gray-200">61,90</td>
          </tr>
        </tbody>
      </table>
    </div>
  </Layout>
)

export default SecondPage
